import { EmptyTab } from '../components/empty-tab';
import { FC } from 'react';

export const TabBookmark: FC = () => {
  return (
    <div className="user-content-section bookmark">
      <EmptyTab tab={'favorites'} variant={'private'} />
    </div>
  );
};

export const TabHeart: FC = () => {
  return (
    <div className="user-content-section heart">
      <EmptyTab tab="likes" variant={'private'} />
    </div>
  );
};
